import { ENDPOINTS } from 'pages/common/consts/endpoints';
import { isKazakhstanRegion } from '../../../common/helpers/is-kazakhstan-region';
import { getCreateConfigurationBody } from './get-create-configuration-body';
import { TData } from '../../../entries/common/widgets/context';
import { setConfigurationIdCookie } from '../../common/helpers/set-configuration-id-cookie';
import { userProjectConfigurationCookieNames } from '../../project-configuration/const';

type TParams = {
  data: TData;
  inputParameters: {
    layerThickness?: number | null;
    height?: number | null;
    width?: number | null;
    length?: number | null;
    areaUser?: number | null;
  };
  thickness: string | null;
  authorizedCustomerId: string | undefined;
  unauthorizedCustomerId: string | undefined;
  isLaminateCalculatorId: boolean;
  calculationCoefficient?: number;
};

export const createConfiguration = async ({
  data,
  inputParameters,
  thickness,
  authorizedCustomerId,
  unauthorizedCustomerId,
  isLaminateCalculatorId,
  calculationCoefficient,
}: TParams) => {
  try {
    const isKazakhstan = isKazakhstanRegion(data.regionId);
    const createConfigurationBody = getCreateConfigurationBody({
      authorizedCustomerId,
      unauthorizedCustomerId,
      isKazakhstan,
      inputParams: inputParameters,
      calculatorId: data.surfaces.id,
      typeInstallation: thickness,
      calculationCoefficient,
    });
    const { projectConfigurationId } = await data.api.post(
      `${ENDPOINTS.CREATE_CONFIGURATION}`,
      createConfigurationBody
    );
    if (isLaminateCalculatorId) {
      setConfigurationIdCookie({
        projectConfigurationId,
        projectConfigurationCookieName: userProjectConfigurationCookieNames.LAMINATE,
      });
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('create room failed', e);
  }
};
